import type { TagProps } from '@superdispatch/ui';
import type { LoadStatus } from '../data/LoadDTO';

export function getLoadStatusColor(status: LoadStatus): TagProps['color'] {
  switch (status) {
    case 'revoked':
      return 'red';
    case 'accepted':
      return 'grey';
    case 'offered':
      return 'purple';
    case 'new':
      return 'teal';
    case 'picked_up':
      return 'yellow';
    default:
      return 'green';
  }
}
